/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface IBusinessPartnerPromotionTermsParagraphProp {
    description: string;
    className: string;
    title?: string;
    titleClassName?: string;
}

export const BusinessPartnerPromotionTermsParagraph: React.FC<IBusinessPartnerPromotionTermsParagraphProp> = ({
    title,
    description,
    className,
    titleClassName
}) => {
    return (
        <li className={className}>
            {title && <p className={titleClassName}>{title}</p>}
            <p>{description}</p>
        </li>
    );
};

export default BusinessPartnerPromotionTermsParagraph;
